import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M94 30h12v140H94z" }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "10",
      d: "M50 60q50 20 100 0M46 84q54 20 108 0M46 108q54 20 108 0M50 132q50 20 100 0"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "100",
      cy: "32",
      r: "14"
    }, null, -1)
  ]))]))
}
export default { render: render }